import i18n from 'i18next';
import { z } from 'zod';

export const giftProductSchema = z.object({
  message: z.string(),
  email: z.string().email(i18n.t("inputs.email.error")),
  confirmEmail: z.string().email(i18n.t("inputs.email.error")),
  firstName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.firstName.error"))
    .max(30, i18n.t("inputs.firstName.maxLengthError")),
  lastName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.lastName.error"))
    .max(30, i18n.t("inputs.lastName.maxLengthError")),
  images: z.array(z.string()),
}).refine((data) => data.email === data.confirmEmail, {
  message: i18n.t("gift.confirmEmail.error"),
  path: ["confirmEmail"],
});

export const sellProductSchema = z.object({
  email: z.string().email(i18n.t("inputs.email.error")),
  confirmEmail: z.string().email(i18n.t("inputs.email.error")),
  firstName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.firstName.error"))
    .max(30, i18n.t("inputs.firstName.maxLengthError")),
  lastName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.lastName.error"))
    .max(30, i18n.t("inputs.lastName.maxLengthError")),
}).refine((data) => data.email === data.confirmEmail, {
  message: i18n.t("gift.confirmEmail.error"),
  path: ["confirmEmail"],
});

export const sendCareRequestSchema = z.object({
  reason: z.string().min(2, i18n.t("inputs.category.error")),
  partner: z.string(),
  comment: z.string(),
})

export const unlockProductSchema = z.object({
  uid: z.string().min(2, i18n.t('inputs.uid.error')),
});